import  { useEffect, useState } from "react";
import {  Table, message, Select, Input, Row, Col } from "antd";
import { getVehicleUuid } from "../api/vehicle/vehicleUuidRequest";

const { Option } = Select;
const { Search } = Input;

const VehicleUuidPage = () => {
  const [uuids, setUuids] = useState([]);
  const [filteredUuids, setFilteredUuids] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPrefix, setSelectedPrefix] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const fetchUuids = async () => {
    setLoading(true);
    try {
      const response = await getVehicleUuid();
      setUuids(response);
      setFilteredUuids(response);
    } catch (error) {
      message.error("Échec du chargement des UUIDs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUuids();
  }, []);

  const handleTableChange = (pagination, filters, sorter) => {
    setPagination(pagination);
  };

  const applyFilters = () => {
    let filtered = uuids;

    if (selectedPrefix) {
      filtered = filtered.filter((item) => item.prefix === selectedPrefix);
    }

    if (searchText) {
      filtered = filtered.filter((item) =>
        item.uuid.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    setFilteredUuids(filtered);
    setPagination({ ...pagination, current: 1 });
  };

  useEffect(() => {
    applyFilters();
  }, [selectedPrefix, searchText, uuids]);

  const uniquePrefixes = [...new Set(uuids.map((item) => item.prefix))].sort();

  const columns = [
    {
      title: "Préfixe",
      dataIndex: "prefix",
      key: "prefix",
      sorter: (a, b) => a.prefix.localeCompare(b.prefix),
    },
    {
      title: "UUID",
      dataIndex: "uuid",
      key: "uuid",
    },
    {
      title: "Utilisé",
      dataIndex: "used",
      key: "used",
      render: (text, record) => (
        <span className={record.used ? "text-green-500" : "text-red-500"}>
          {record.used ? "Oui" : "Non"}
        </span>
      ),
    },
  ];

  return (
    <div className="p-6 space-y-4">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold">UUIDs d'vehicule</h1>
      </div>

      <Row gutter={16} className="mb-4">
        <Col xs={24} sm={12} md={8}>
          <Select
            placeholder="Filtrer par préfixe"
            style={{ width: "100%" }}
            onChange={setSelectedPrefix}
            allowClear
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {uniquePrefixes.map((prefix) => (
              <Option key={prefix} value={prefix}>
                {prefix}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Search
            placeholder="Rechercher UUID..."
            allowClear
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: "100%" }}
          />
        </Col>
      </Row>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={filteredUuids}
        loading={loading}
        pagination={{
          ...pagination,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} sur ${total} éléments`,
        }}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default VehicleUuidPage;
